export enum CountryCodes {
  GERMANY = 'DE',
  GB = 'GB',
}
